import type { TagColor } from '../types';
type TagColorResult = {
  tagBackground?: string;
  tagTextColor?: string;
  hierarchy: 'primary' | 'secondary';
};
export const getTagColors = ({
  tagColor,
  isExpanded
}: {
  tagColor?: TagColor;
  isExpanded: boolean;
}): TagColorResult => {
  if (!tagColor) {
    return {
      hierarchy: isExpanded ? 'primary' : 'secondary'
    };
  }
  if (isExpanded) {
    return {
      hierarchy: 'primary',
      tagBackground: tagColor.primary,
      tagTextColor: tagColor.tertiary ?? '#FFFFFF'
    };
  }
  return {
    hierarchy: 'secondary',
    tagBackground: tagColor.secondary ?? tagColor.primary,
    tagTextColor: tagColor.primary
  };
};